
import { useMutation, useQuery } from "@tanstack/react-query";
import { commentService } from "services";
import { FormCommentStore, IdForm } from "types";
import SnackbarUtils from "utils/SnackbarUtils";

export function useComment() {

    const getList = async (projectId, taskId, page = 1) => {
        const data = await commentService.onGetList(projectId, taskId, page);
        return data;
    };

    const fetchData = (projectId, taskId, currentPage, isFetch = 1) => {
        return useQuery({
            queryKey: ['comments', projectId, taskId, currentPage, isFetch],
            queryFn: () => getList(projectId, taskId, currentPage),
            enabled: !!projectId && !!taskId,
            staleTime: 1000 * 60 * 3,
            select: (data) => ({
                data: data?.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }

    const createComment = useMutation({
        mutationFn: (payload: FormCommentStore) => commentService.store(payload),
        onSuccess: async (res) => {
            if (res?.statusCode !== 200) {
                SnackbarUtils.error(res?.message ?? "Tạo bình luận lỗi!");
            }
            return res;
        },
        onError: (err) => {
            console.error("createComment failed", err);
        },
    });


    const delComment = useMutation({
        mutationFn: (formData: IdForm) => commentService.destroy(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("delComment failed", err);
        },
    });

    return { fetchData, getList, createComment, delComment }
}
